import CourseMainContent from './CourseMainContent';
import CourseContentLeft from './CourseContentLeft';

function Courses() {
  return (
    <div className="grid grid-cols-12 min-h-screen bg-grey-super_light">
      <div className="col-span-0 md:col-span-3" />

      <div className="col-span-12 md:col-span-6">
        <CourseMainContent />
      </div>
    </div>
  );
}

Courses.propTypes = {};

export default Courses;
